"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CorporateIdentity = exports.CorporateIdentityNumberErrors = void 0;
var CorporateIdentityNumberErrors;
(function (CorporateIdentityNumberErrors) {
    CorporateIdentityNumberErrors["InputType"] = "INPUT_TYPE";
    CorporateIdentityNumberErrors["Format"] = "FORMAT";
    CorporateIdentityNumberErrors["Checksum"] = "CHECKSUM";
    CorporateIdentityNumberErrors["GroupNumber"] = "GROUP_NUMBER";
    CorporateIdentityNumberErrors["ValidationNumber"] = "ORGANISATIONS_VALIDATION_NUMBER";
    CorporateIdentityNumberErrors["NumberIdentifer"] = "ORGANISATIONS_NUMBER_IDENTIFIER";
})(CorporateIdentityNumberErrors = exports.CorporateIdentityNumberErrors || (exports.CorporateIdentityNumberErrors = {}));
var CorporateIdentity;
(function (CorporateIdentity) {
    CorporateIdentity["DeadEstate"] = "D\u00F6dsbon";
    CorporateIdentity["Government"] = "Stat, landsting, kommuner, f\u00F6rsamlingar";
    CorporateIdentity["Foreign"] = "Utl\u00E4ndska f\u00F6retag som bedriver n\u00E4ringsverksamhet eller \u00E4ger fastigheter i Sverige";
    CorporateIdentity["LimitedCompany"] = "Aktiebolag";
    CorporateIdentity["SimpleCompany"] = "Enkelt bolag";
    CorporateIdentity["EconomicAssociation"] = "Ekonomiska f\u00F6reningar";
    CorporateIdentity["NonProfitOrganization"] = "Ideella f\u00F6reningar och stiftelser";
    CorporateIdentity["TradingCompany"] = "Handelsbolag, kommanditbolag och enkla bolag";
})(CorporateIdentity = exports.CorporateIdentity || (exports.CorporateIdentity = {}));
